import Vue from 'vue'
import vmodal from 'vue-js-modal'

Vue.use(vmodal, {
  dynamicDefaults: {
    adaptive: true,
    height: 'auto',
    shiftY: 0,
  }
})